import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "result-modal" }

import { ref } from 'vue'
import events from '@gd/event-bus'
import { useStore } from '@/store'

import CResultGameInfo from '@/components/CResultGameInfo.vue'
import CResultTable from '@/components/CResultTable.vue'
import { CsFormPreselections, getSubTopic } from '@/lib/customerService'
import GameState from '../model/GameState'
import CCustomerService from '@/components/CCustomerService.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MResultModal',
  props: {
    competitionId: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const store = useStore()

const show = ref(false)

function created() {
  store
    .dispatch('results/fetchCompetitionResultById', props.competitionId)
    .then(() => {
      // handle progress spinner while loading
      show.value = true
    })
    .catch((err: any) => {
      emit('close')
    })
}
function close() {
  emit('close')
}

function onCustomer() {
  events.$emit('cs-form', {
    topic: 'duelError',
    subTopic: getSubTopic(store.getters['results/zoneId']),
    competitionId: props.competitionId,
  } as CsFormPreselections)
}

created()

return (_ctx: any,_cache: any) => {
  const _component_c_loading_indicator = _resolveComponent("c-loading-indicator")!
  const _component_modal_content = _resolveComponent("modal-content")!
  const _component_t_button = _resolveComponent("t-button")!
  const _component_modal_actions = _resolveComponent("modal-actions")!
  const _component_modal_layout = _resolveComponent("modal-layout")!
  const _component_modal_app = _resolveComponent("modal-app")!
  const _component_gd_modal = _resolveComponent("gd-modal")!

  return (_openBlock(), _createBlock(_component_gd_modal, {
    onCloseBG: close,
    onCloseESC: close,
    onClose: close
  }, {
    default: _withCtx(() => [
      _createVNode(_component_c_loading_indicator, {
        show: !show.value
      }, null, 8, ["show"]),
      _createVNode(_component_modal_app, { l: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_modal_layout, null, {
            default: _withCtx(() => [
              _createVNode(_component_modal_content, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(CResultGameInfo, {
                      data: _unref(store).getters['results/ownRanking'],
                      "data-qe-id": "game-info",
                      class: "result-game-info"
                    }, null, 8, ["data"]),
                    _createVNode(CResultTable, {
                      data: _unref(store).getters['results/rankingTable'],
                      state: _unref(GameState).FINISHED,
                      "data-qe-id": "ranking-table",
                      "only-game-result": true
                    }, null, 8, ["data", "state"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(CCustomerService, {
                      onCustomer: onCustomer,
                      text: _ctx.$t('resultView.customerService.headline', { competitionId: _ctx.competitionId })
                    }, null, 8, ["text"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_modal_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_t_button, { onClick: close }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('generic.app.button_modal_close')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})